// extracted by mini-css-extract-plugin
export default {"header":"header_header__zmCjr","title":"header_title__S9Zsd"};